"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELIGIBILITY_LIST_OPERATORS = exports.ELIGIBILITY_NULL_OPERATORS = exports.OPERATORS_BY_FACT_KIND = exports.eligibilityConditionRoleSchema = exports.ELIGIBILITY_CONDITION_ROLES = exports.eligibilityRuleSeveritySchema = exports.ELIGIBILITY_RULE_SEVERITIES = exports.eligibilityFactKindSchema = exports.ELIGIBILITY_FACT_KINDS = exports.eligibilityOperatorSchema = exports.ELIGIBILITY_OPERATORS = void 0;
exports.isEligibilityOperatorSupportedForKind = isEligibilityOperatorSupportedForKind;
exports.isEligibilityNullOperator = isEligibilityNullOperator;
exports.isEligibilityListOperator = isEligibilityListOperator;
const zod_1 = require("zod");
exports.ELIGIBILITY_OPERATORS = [
    'eq',
    'ne',
    'gt',
    'gte',
    'lt',
    'lte',
    'in',
    'not_in',
    'contains',
    'starts_with',
    'ends_with',
    'is_null',
    'is_not_null',
];
exports.eligibilityOperatorSchema = zod_1.z.enum(exports.ELIGIBILITY_OPERATORS);
exports.ELIGIBILITY_FACT_KINDS = ['numeric', 'string', 'boolean', 'enum', 'date'];
exports.eligibilityFactKindSchema = zod_1.z.enum(exports.ELIGIBILITY_FACT_KINDS);
exports.ELIGIBILITY_RULE_SEVERITIES = ['blocking', 'curable'];
exports.eligibilityRuleSeveritySchema = zod_1.z.enum(exports.ELIGIBILITY_RULE_SEVERITIES);
exports.ELIGIBILITY_CONDITION_ROLES = ['requirement', 'guard'];
exports.eligibilityConditionRoleSchema = zod_1.z.enum(exports.ELIGIBILITY_CONDITION_ROLES);
// This map is forked from OPERATORS_BY_FIELD_KIND in schemas/approval-rules.ts. A drift test keeps both maps in sync.
exports.OPERATORS_BY_FACT_KIND = {
    numeric: ['eq', 'ne', 'gt', 'gte', 'lt', 'lte', 'in', 'not_in', 'is_null', 'is_not_null'],
    enum: ['eq', 'ne', 'in', 'not_in', 'is_null', 'is_not_null'],
    string: [
        'eq',
        'ne',
        'contains',
        'starts_with',
        'ends_with',
        'in',
        'not_in',
        'is_null',
        'is_not_null',
    ],
    boolean: ['eq', 'ne', 'is_null', 'is_not_null'],
    date: ['eq', 'ne', 'gt', 'gte', 'lt', 'lte', 'is_null', 'is_not_null'],
};
function isEligibilityOperatorSupportedForKind(operator, kind) {
    return exports.OPERATORS_BY_FACT_KIND[kind].includes(operator);
}
exports.ELIGIBILITY_NULL_OPERATORS = ['is_null', 'is_not_null'];
exports.ELIGIBILITY_LIST_OPERATORS = ['in', 'not_in'];
function isEligibilityNullOperator(op) {
    return exports.ELIGIBILITY_NULL_OPERATORS.includes(op);
}
function isEligibilityListOperator(op) {
    return exports.ELIGIBILITY_LIST_OPERATORS.includes(op);
}
//# sourceMappingURL=vocabulary.js.map